var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H5V20H12M9 12H19M19 12L14.5 7.5M19 12L14.5 16.5",
    stroke: "#3B445A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4.00002L4 4L4 19.9991C4.00002 20.5514 4.44773 21 5.00002 21H12C12.5522 21 13 20.5523 13 20C13 19.4477 12.5522 19 12 19H6.00021L5.99998 5.00001L12 5C12.5522 5 13 4.55228 13 4C13 3.44772 12.5522 3 12 3L5.00007 3.00002L5 4.00002ZM5 4.00002L5.00007 3.00002C4.4478 3.00002 4.00002 3.44773 4 4L5 4.00002ZM13.8485 6.84856C14.239 6.45803 14.8722 6.45803 15.2627 6.84856L19.7072 11.293C20.0977 11.6835 20.0977 12.3167 19.7072 12.7072L15.2627 17.1517C14.8722 17.5422 14.239 17.5422 13.8485 17.1517C13.458 16.7611 13.458 16.128 13.8485 15.7374L16.5859 13.0001L8.99995 13C8.44767 13 7.99996 12.5523 7.99996 12C7.99997 11.4477 8.44769 11 8.99997 11L16.5858 11.0001L13.8485 8.26277C13.458 7.87225 13.458 7.23908 13.8485 6.84856Z",
    fill: "#3B445A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5c88e6a68b10d00bd8deee06680a9293.svg";
export { ForwardRef as ReactComponent };